// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DubxO","colBig":"styles_colBig__-WCNJ","colSmall":"styles_colSmall__X-kgG","shopifyNameWrapper":"styles_shopifyNameWrapper__2vxw3"};